"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
class System {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.System = System;
//# sourceMappingURL=System.js.map